import API_URLS from "constants/apis.url.js";

import { getRequest } from "./api.js";

const ANALYTICS_BASE_URL = API_URLS.analyticsURL;

export const getAnalyticsData = params => {
  const URL = `${ANALYTICS_BASE_URL}/cip`;
  return getRequest(URL, true, { params });
};
